import './style.scss'
import { useState } from 'react'
import { ScreenContainer } from "src/style"
import utility from "src/utils/utility"
import { CustomerInfo } from "src/component"

const CustomerData = () => {

    return (
        <>
            <ScreenContainer
                leftPadding='2.5' rightPadding='2.5'
                topPadding='1.5' bottomPadding='1.5'
            >
                <CustomerInfo />
            </ScreenContainer>
        </>
    )
}

export default utility.routeData('customer-data', 'Customer Data', <CustomerData/>)